import { NotFoundIcon } from '../$portalId/-components/assets/not-found-icon';
import { Footer } from '../$portalId/-components/footer';
import { Header } from '../$portalId/-components/header';
import { DivWithPrimaryColorVariable } from '../$portalId/-components/div-with-primary-color-variable';
import { ErrorBoundary } from 'react-error-boundary';

export function NotFound() {
	return (
		// NotFound page can fail if there is not portal for this subdomain, so we fallback to a simple 404 page
		<ErrorBoundary
			fallback={
				<main className="m-auto flex max-w-[1366px] flex-1 gap-6 px-12 py-24 lg:gap-12">
					<div className="flex flex-col items-center justify-center gap-6 p-6">
						<NotFoundIcon className="text-primary" />
						<h1 className="text-primary/70 text-4xl font-bold">404</h1>
					</div>
				</main>
			}
		>
			<Header />

			<main className="m-auto flex max-w-[1366px] flex-1 gap-6 px-12 py-24 lg:gap-12">
				<DivWithPrimaryColorVariable className="flex flex-col items-center justify-center gap-6 p-6">
					<NotFoundIcon className="text-primary" />
					<h1 className="text-primary/70 text-4xl font-bold">404</h1>
				</DivWithPrimaryColorVariable>
			</main>

			<Footer />
		</ErrorBoundary>
	);
}
